import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Header from 'components/header/Header';
import Footer from 'components/footer/Footer';
import Content from 'components/Content';
import './ForgotPassword.scss';

import { initForgotPassword, asyncForgotPassword, asyncResetPassword } from 'actions/auth';

export class ForgotPassword extends Component {
  state = {
    email: '',
    pin: '',
    password: '',
    passwordConfirm: ''
  };

  componentDidMount() {
    this.props.init();
    document.title = 'Doodly: Password reset';
  }

  componentDidUpdate(prevProps, prevState) {}

  handleInputChange(fieldName, event) {
    let newState = {};
    newState[fieldName] = event.currentTarget.value;
    this.setState(newState);
  }

  handleFormSubmit = event => {
    const { email, pin, password, passwordConfirm } = this.state;
    const { forgotPassword, resetPassword, tokenSent } = this.props;
    event.preventDefault();
    if (tokenSent) {
      resetPassword(pin, email, password, passwordConfirm);
    } else {
      forgotPassword(email);
    }
  };

  render() {
    const { email, pin, password, passwordConfirm } = this.state;
    const { isResettingPassword, tokenSent, isPasswordReset } = this.props;
    return (
      <div className="forgot-password">
        <Header />
        <Content>
          <div className="sheet">
            <h2>Forgot password?</h2>
            {isPasswordReset ? (
              <p>
                Your password has been reset. Click <Link to="/login">here</Link> to login again.
              </p>
            ) : tokenSent ? (
              <p>
                We have emailed you the password reset PIN. Please enter it in the field below along with the new
                password.
              </p>
            ) : (
              <p>Enter your email in the box below and we'll email you a password resetting PIN.</p>
            )}

            {!isPasswordReset && (
              <div className="row">
                <form action="" className="form col-md-7" onSubmit={this.handleFormSubmit}>
                  <div className="form-group">
                    <input
                      type={tokenSent ? 'hidden' : 'email'}
                      className="form-control"
                      placeholder="Email"
                      value={email}
                      onChange={this.handleInputChange.bind(this, 'email')}
                      required
                    />
                  </div>

                  {tokenSent && (
                    <>
                      <div className="form-group d-flex align-items-center">
                        <label className="col-md-4 text-right mr-2">Password reset PIN</label>
                        <input
                          name="pin"
                          type="text"
                          className="form-control"
                          value={pin}
                          onChange={this.handleInputChange.bind(this, 'pin')}
                          required
                        />
                      </div>
                      <div className="form-group d-flex align-items-center">
                        <label className="col-md-4 text-right mr-2">New password</label>
                        <input
                          type="password"
                          className="form-control"
                          value={password}
                          onChange={this.handleInputChange.bind(this, 'password')}
                          required
                        />
                      </div>
                      <div className="form-group d-flex align-items-center">
                        <label className="col-md-4 text-right mr-2">Password again</label>
                        <input
                          type="password"
                          className="form-control"
                          value={passwordConfirm}
                          onChange={this.handleInputChange.bind(this, 'passwordConfirm')}
                          required
                        />
                      </div>
                    </>
                  )}
                  <div className="d-flex">
                    <div className="col-md-4"></div>
                    <div className="col-md-8 d-flex justify-content-around">
                      <button className="btn btn-green">
                        {isResettingPassword ? 'Processing...' : tokenSent ? 'Reset Password' : 'Submit'}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            )}
          </div>
        </Content>
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { auth } = state;
  return {
    isResettingPassword: auth.isResettingPassword,
    tokenSent: auth.resetPasswordTokenSent,
    isPasswordReset: auth.isPasswordReset
  };
};

const mapDispatchToProps = dispatch => ({
  init: () => dispatch(initForgotPassword()),
  forgotPassword: email => dispatch(asyncForgotPassword(email)),
  resetPassword: (pin, email, password, passwordConfirm) =>
    dispatch(asyncResetPassword(pin, email, password, passwordConfirm))
});

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);
